import React from 'react';
import { Environment, User, ConnectionConfig } from '../types';
import { LogOut } from 'lucide-react';

interface HeaderProps {
  activeEnv: Environment | null;
  user: User | null;
  onLogin: () => void;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({
  activeEnv, user,
  onLogin, onLogout
}) => {
  const hasAnyConnection = activeEnv ? (Object.values(activeEnv.connections) as ConnectionConfig[]).some(v => v.connected) : false;

  const handleGoogleLogin = () => {
    window.location.href = '/api/auth/google/start';
  };

  return (
    <header className="h-14 bg-white border-b border-slate-200 px-8 flex items-center justify-end sticky top-0 z-[40] shadow-sm">
      <div className="flex items-center gap-6">
        {activeEnv && (
          <div className={`flex items-center gap-2 px-3 py-1.5 border rounded-full text-[9px] font-black uppercase tracking-wider transition-all duration-500 ${
            hasAnyConnection ? 'bg-green-50 text-green-700 border-green-200' : 'bg-slate-50 text-slate-400 border-slate-200'
          }`}>
            <span className={`h-2 w-2 rounded-full ${hasAnyConnection ? 'bg-green-500 animate-pulse' : 'bg-slate-300'}`}></span>
            {activeEnv.isSample ? 'Sample Data' : (hasAnyConnection ? 'Live Data' : 'Not Connected')}
          </div>
        )}

        {user ? (
          <div className="flex items-center gap-4 border-l pl-6 border-slate-100">
            {user.avatar && (
              <img
                src={user.avatar}
                alt={user.name}
                className="w-8 h-8 rounded-full border-2 border-slate-200"
              />
            )}
            <div className="text-right">
              <p className="text-xs font-black text-slate-900 leading-none">{user.name}</p>
              <p className="text-[9px] text-slate-400 font-bold uppercase mt-1">{user.role}</p>
            </div>
            <button onClick={onLogout} className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all" title="Logout">
              <LogOut size={18} />
            </button>
          </div>
        ) : (
          <button
            onClick={handleGoogleLogin}
            className="flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-lg text-xs font-bold hover:bg-black hover:scale-[1.02] active:scale-95 transition-all shadow-md"
          >
            Sign In with Google
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
